import __var_0__ from '@stdlib/assert/is-number';
import __var_1__ from '@stdlib/math/base/assert/is-infinite';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isNumber = __var_0__.isPrimitive;
var isinf = __var_1__;


// MAIN //

/**
* Tests if a value is a number primitive having an infinite value.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating if a value is a number primitive having an infinite value
*
* @example
* var bool = isInfinite( -1.0/0.0 );
* // returns true
*
* @example
* var bool = isInfinite( new Number( -1.0/0.0 ) );
* // returns false
*/
function isInfinite( value ) {
	return (
		isNumber( value ) &&
		isinf( value )
	);
}


// EXPORTS //
export default isInfinite;
